import { atom, useAtom } from "jotai";
import { useState } from "react";
import { deleteCompany } from "../../../../../../../services/companyService";

const companyAtom = atom(null);
const bottomPanelContentAtom = atom("");
const bottomPanelParamsAtom = atom(null);
const isShowingCommentAtom = atom(false);
const isDeletedAtom = atom(false);
const openedPanelNameAtom = atom("");

const useCompanyItem = () => {
  const [company, setCompany] = useAtom(companyAtom);
  const [bottomPanelContent, setBottomPanelContent] = useAtom(
    bottomPanelContentAtom
  );
  const [bottomPanelParams, setBottomPanelParams] = useAtom(
    bottomPanelParamsAtom
  );
  const [isShowingComment, setIsShowingComment] = useAtom(isShowingCommentAtom);
  const [isDeleted, setIsDeleted] = useAtom(isDeletedAtom);
  const [isDeleting, setIsDeleting] = useState(false);
  const [openedPanelName, setOpenedPanelName] = useAtom(openedPanelNameAtom);

  const initCompany = (data) => {
    setCompany({ ...data });
  };

  const openBottomPanel = (panelName, params = null) => {
    // const isOpened = bottomPanelContent == panelName;
    const isOpened = false;
    setOpenedPanelName(panelName);
    // document.querySelector(`#leaditem${company?.id}`)?.scrollIntoView();
    setBottomPanelContent(isOpened && !params ? null : panelName);
    setBottomPanelParams(params);
  };

  const onRemoveCompany = () => {
    if (window.confirm("Confirmez-vous la suppression de cette entreprise ?")) {
      setIsDeleting(true);
      deleteCompany(company.id)
        .then((data) => setIsDeleted(true))
        .finally(() => setIsDeleting(false));
    }
  };

  const closeBottomPanel = () => {
    setBottomPanelContent("");
    setBottomPanelParams(null);
  };

  const toggleIsShowingComment = () => {
    setIsShowingComment(!isShowingComment);
  };

  const populateCompanyUsers = (users) => {
    setCompany({ ...company, users });
  };

  const onToggleAvecEcheancier = (policyId) => {
    setCompany({
      ...company,
      policies: company.policies.map((pol) => {
        if (pol.id == policyId) {
          return { ...pol, avecEcheancier: !pol.avecEcheancier };
        } else {
          return pol;
        }
      }),
    });
  };

  return {
    company,
    bottomPanelContent,
    bottomPanelParams,
    isShowingComment,
    isDeleted,
    isDeleting,
    openedPanelName,
    actions: {
      initCompany,
      openBottomPanel,
      closeBottomPanel,
      toggleIsShowingComment,
      populateCompanyUsers,
      onRemoveCompany,
      setCompany,
      onToggleAvecEcheancier,
    },
  };
};

export default useCompanyItem;
